module.exports = __webpack_public_path__ + "img/logo_bank_muamalat.e1b8cab0.png";